export const WEBAPPVERSION = "v2605r1-rc1"
